import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { DataService_BusTrackerMap } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-school-bus-alert-table",
	templateUrl: "./school-bus-alert-table.component.html",
	styleUrls: ["./school-bus-alert-table.component.css"],
})
export class SchoolBusAlertTableComponent implements OnInit {
	constructor(private userService: UserService, private mapService: DataService_BusTrackerMap, private dialogService: DialogService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadSchoolAlertTxn();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSchoolAlertTxn: any;
	lstSchoolAlertTxn: any = [];

	//Filter lists
	lstAlertTypeCD: any = [];
	lstAlertTypeDesc: any = [];
	lstSeverityDesc: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols1: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "AlertTypeCD", header: "Type Code" },
		{ field: "AlertTypeDesc", header: "Type Description" },
		{ field: "SeverityDesc", header: "Severity" },
		{ field: "StartDTDesc", header: "Start" },
		{ field: "EndDTDesc", header: "End" },
		{ field: "Comments", header: "Comments" },
		// { field: 'ActiveDesc', header: 'Active' },
		// { field: 'BusNbr', header: 'Bus' },
		// { field: 'PersonName', header: 'Created By' },
	];

	cols2: any = [
		{ field: "BusNbr", header: "Bus" },
		{ field: "PersonName", header: "Created By" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchoolAlertTxn() {
		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			return;
		}

		this.loading = true;

		var result = this.mapService.SchoolAlertSelectList(fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstSchoolAlertTxn = response;

				//Load Data Filter Lists
				this.lstAlertTypeCD = Array.from(new Set(this.lstSchoolAlertTxn.map((item: any) => item.AlertTypeCD))).sort();
				this.lstAlertTypeDesc = Array.from(new Set(this.lstSchoolAlertTxn.map((item: any) => item.AlertTypeDesc))).sort();
				this.lstSeverityDesc = Array.from(new Set(this.lstSchoolAlertTxn.map((item: any) => item.SeverityDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstSchoolAlertTxn.map((item: any) => item.ActiveDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadSchoolAlertTxn();
	}

	//Custom Button Methods

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onStartDateChange(val) {
		this.StartDate = val;

		this.loadSchoolAlertTxn();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		this.loadSchoolAlertTxn();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedSchoolAlertTxn = val.data;
	}
	onRowUnselect(val) {
		this.SelectedSchoolAlertTxn = null;
	}
	onRowDblClick(SchoolAlertTxn) {
		this.SelectedSchoolAlertTxn = SchoolAlertTxn;
		// this.onEditSchoolAlertTxn();
	}
	////////////////////////////////////////////
}
